import { ENV as DEV_ENV } from './environment.dev';
import { ENV as PROD_ENV } from './environment.prod';
import {Stage} from "@zooplus/commons-lang";

export const getEnvironment = (): Stage => {
  const url = window.location.href;
  if (
    url.includes('k8s') ||
    url.includes('develop') ||
    url.includes('release') ||
    url.includes('localhost') ||
    url.includes('feature')
  )
    return 'dev';
  else return 'prod';
};

const ENV = getEnvironment() === 'dev' ? DEV_ENV : PROD_ENV;

export default ENV;
